// ink-component
import React from 'react';
import styled from 'styled-components';
import Text from '../../../Typography/Text/Text';

export type NewTextAreaCounterProps = {
  /** TextArea value */
  value?: number | string;
  /** TextArea maxLength */
  maxLength?: number | string;
};

const CounterWrapper = styled.div`
  text-align: right;
`;

/**
 * @purpose Allows users to see how many characters they can still type
 * @categories form
 * @group NewTextArea
 * @position 2
 */
function Counter(props: NewTextAreaCounterProps) {
  const { value, maxLength } = props;
  return (
    <CounterWrapper>
      <Text variant="small-2">{`${value ? value.toString().length : 0} of ${maxLength || 0} characters`}</Text>
    </CounterWrapper>
  );
}

Counter.defaultProps = {
  value: undefined,
  maxLength: undefined,
};

Counter.displayName = 'NewTextArea.Counter';

export default Counter;
